<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>Configurações</v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
      <v-col md="4" sm="4" lg="4" v-if="isSala">
        <app-axis-by-project-combobox
          :filter="filter"
          :name="'Eixos permitidos da tela de diagnóstico e evidências'"
        >
        </app-axis-by-project-combobox>
      </v-col>
    </v-row>
    <v-row class="mt-4 mb-4" v-if="isSala">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Introdução Relatório Final Municipio
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col>
              <vue-editor id="editor1" v-model="editor1Content"></vue-editor>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="value"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
          :expanded="expanded"
        >
          <template v-slot:header.habilitado="{ header }">
            <span>
              {{ header.text }}
              <AppYesOrNOCombobox
                :editValue="all"
                :value="'habilitado'"
                @onChange="
                  value = value.map((item) => {
                    return {
                      ...item,
                      habilitado: all.habilitado,
                    };
                  })
                "
              ></AppYesOrNOCombobox>
            </span>
          </template>
          <template v-slot:item="{ item }">
            <tr
              :class="`${
                expanded.length > 0 && item === expanded[0] ? 'expanded' : ''
              }`"
            >
              <td>
                {{ item.text }}
              </td>
              <td>
                <v-btn color="primary" @click="openExpanded(item)">
                  Descrição
                </v-btn>
              </td>
              <td>
                <AppYesOrNOCombobox :editValue="item"></AppYesOrNOCombobox>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ item }">
            <tr class="description">
              <td colspan="9" class="p-0">
                <ul>
                  <li
                    v-for="(description, index) in item.description"
                    :key="index"
                  >
                    {{ description }}
                  </li>
                </ul>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhuma Configuração </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="text-align: end">
        <button @click="saveConfig()">salvar</button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppYesOrNOCombobox from "./Combobox";
import { configuracoesAPI } from "../API/configuracoesAPI";
import { filterConfigText, initialConfig } from "../utils/utils";
import AppAxisByProjectCombobox from "./ComboboxEixo.vue";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    AppYesOrNOCombobox,
    AppAxisByProjectCombobox,
    VueEditor,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "text", width: "70%" },
        { text: "Action", value: "text", width: "10%" },
        {
          text: "Habilitado",
          value: "habilitado",
          width: "20%",
          sortable: false,
        },
      ],
      initialValue: JSON.parse(localStorage.getItem("config")),
      initialConfig: initialConfig,
      value: [],
      filter: { eixo: [] },
      search: "",
      editor1Content: "",
      expanded: [],
      all: { habilitado: false },
    };
  },

  methods: {
    ...mapActions(["setLoading", "setConfig"]),
    openExpanded(evidenceSlot) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }
    },
    load(data) {
      let t = Object.entries({ ...this.initialValue, ...data }).map((entry) => {
        return { [entry[0]]: entry[1] };
      });

      this.value = t
        .map((item) => {
          if (item.visualizaEixosIds) {
            this.filter.eixo = JSON.parse(item.visualizaEixosIds || "[]");
          }

          return {
            habilitado: Object.values(item)[0],
            text:
              filterConfigText(Object.keys(item)[0]) &&
              filterConfigText(Object.keys(item)[0]).text,
            description:
              filterConfigText(Object.keys(item)[0]) &&
              filterConfigText(Object.keys(item)[0]).description,
            id: Object.keys(item)[0],
          };
        })
        .filter((item) => item.text)
        .sort(function (a, b) {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
      this.setLoading(false);
    },
    saveConfig(data) {
      this.setLoading(true);

      var finalValue = {
        ...this.initialValue,
        ...this.value.reduce((a, v) => ({ ...a, [v.id]: v.habilitado }), {}),
        visualizaEixosIds: JSON.stringify(this.filter.eixo || "[]"),
        relatorioFinal: this.editor1Content,
      };

      configuracoesAPI
        .update(finalValue)
        .then(() => {
          this.$notification.success("Configuração salva com sucesso");

          this.setConfig(finalValue);
          this.setLoading(false);
        })
        .catch((err) => {
          this.setLoading(false);
          console.log("err: ", err);
          this.$notification.error("Erro ao salvar Configuração");
        });
    },
  },

  async mounted() {
    this.setLoading(true);

    const config = await configuracoesAPI.get();
    const configData = config.data.filter(
      (item) => item.configuracaoId == 1
    )[0];
    this.editor1Content = configData.relatorioFinal;

    this.load(configData);
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config", "isSala"]),
  },
};
</script>
<style scoped lang="scss">
.description {
  background: #edeaea;
  td {
    padding: 0 30px !important;
  }
}
.expanded {
  background: #c9c9c9;
}
button {
  background: #5c8bb9;
  padding: 0.5rem 2rem;
  border-radius: 10px;
  color: #fff;
}
</style>
